export const remindersOverviewKeys = {
    all: ['invoicing', 'reminders'],
    info: (params) => [...remindersOverviewKeys.all, 'info', params],
    invoices: (params) => [...remindersOverviewKeys.all, 'invoices', params],
    upcoming: (days) => [...remindersOverviewKeys.all, 'upcoming', days],
    history: (params) => [...remindersOverviewKeys.all, 'history', params],
    historyStats: () => [...remindersOverviewKeys.all, 'historyStats'],
    rules: () => [...remindersOverviewKeys.all, 'rules'],
    customers: (params) => [...remindersOverviewKeys.all, 'customers', params],
};
